import { inject } from '@angular/core';
import { RedirectCommand, Router, UrlTree } from '@angular/router';
import { UserInfoService } from '../services/user-info.service';

export const userInfoGuard = () => {
  if (inject(UserInfoService).info() !== null) {
    return true;
  }
  const url = new URL(window.location.href);
  const originalUrl = url.pathname === '/' ? undefined : `${url.pathname}${url.search}${url.hash}`;
  const urlTree: UrlTree = inject(Router).parseUrl('/onboarding/user-info');
  return new RedirectCommand(urlTree, { state: { originalUrl } });
};
